import { render } from "./ChannelChatApp.vue?vue&type=template&id=d7356e4e&ts=true"
import script from "./ChannelChatApp.vue?vue&type=script&lang=ts"
export * from "./ChannelChatApp.vue?vue&type=script&lang=ts"

import "./ChannelChatApp.vue?vue&type=style&index=0&id=d7356e4e&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__